import { createSelector } from 'reselect';
import { userCountryCodeSelector } from '../../application/selectors/isUserAccountEnabled';

export const isCCEnabledSelector = createSelector(
  userCountryCodeSelector,
  (userCountryCode) => userCountryCode === 'us',
);
